import { Color3, Tools, Vector3 } from "@babylonjs/core";

const rotations: Record<CameraOrientation, CameraRotationSpecs> = {
    angled: { alpha: Tools.ToRadians(-45), beta: Tools.ToRadians(45) },
    top: { alpha: Tools.ToRadians(-90), beta: 0 },
};

export default class JointSceneSettings {
    camera: CameraOrientation = 'angled';
    formConnectors = false;
    folded = false;
    debug = false;
    axesScale = 10;

    apply(settings: Partial<JointSceneSettings> = {}): JointSceneSettings {
        return Object.assign(new JointSceneSettings(), this, settings);
    }

    get currentCameraRotationSpecs(): CameraRotationSpecs {
        return rotations[this.camera];
    }

    static get defaultArcRotateCameraSpecs(): ArcRotateCameraSpecs {
        return {
            ...rotations['angled'],
            radius: 15,
            lowerRadiusLimit: 15,
            target: new Vector3(0, 0, 0),
        }
    }

    static get defaultHemisphericLightSpecs(): HemisphericLightSpecs {
        return {
            direction: new Vector3(-93, 200, 85),
            diffuse: new Color3(1, 1, 1),
            specular: Color3.Gray(),
            groundColor: Color3.FromHexString('#494949'),
            intensity: 1.2,
        }
    }

}

type CameraOrientation = 'angled' | 'top';

export interface CameraRotationSpecs {
    /** Defines the camera rotation along the longitudinal axis */
    alpha: number,
    /**  Defines the camera rotation along the latitudinal axis */
    beta: number,
}

export interface ArcRotateCameraSpecs extends CameraRotationSpecs {
    /** Defines the camera distance from its target */
    radius: number,
    /**
     * Minimum allowed distance of the camera to the target (The camera can not get closer).
     * This can help limiting how the Camera is able to move in the scene.
     */
    lowerRadiusLimit: number,
    /** Defines the camera target */
    target: Vector3,
}

export type HemisphericLightSpecs = {
    direction: Vector3,
    diffuse: Color3,
    specular: Color3,
    groundColor: Color3,
    intensity: number,
}
